import { ILeaveStatus } from 'src/types/hr_ticket/leaveStatus.type';
import { http } from '@martech-solution/utils/utils';

const controller = 'hr/leave-statuses';

export const getLeaveStatusesDropdown = async () => {
  return await http.get<ILeaveStatus[]>(`${controller}/dropdown`);
};
